import styled from "styled-components";

export const StyledBomPage = styled.div``;